export function lockfileIcon(path: string): string {
  const filename = path.split('/').pop() ?? ''
  const map: Record<string, string> = {
    'package-lock.json': 'javascript',
    'package.json': 'javascript',
    'yarn.lock': 'javascript',
    'pnpm-lock.yaml': 'javascript',
    'requirements.txt': 'python',
    'poetry.lock': 'python',
    'Pipfile.lock': 'python',
    'Gemfile.lock': 'ruby',
    'Cargo.lock': 'rust',
    'gradle.lockfile': 'java',
    'packages.lock.json': 'csharp',
    'go.sum': 'go'
  }
  return map[filename] ?? 'file'
}
